import * as React from "react";
import { useState } from "react";
import {fileTypes} from "../../../consts/consts";
import Checkbox from "../../CheckboxNew";
import Input from "../../Input-new/Input";
import Textarea from "../../Textarea-new/Textarea";
import UploadFiles from "./UploadFiles";
import { isFieldLocked } from "../../../access-levels";

const STATE_NAMES = {
    AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',
    CO:'Colorado',CT:'Connecticut',DE:'Delaware',FL:'Florida',GA:'Georgia',
    HI:'Hawaii',ID:'Idaho',IL:'Illinois',IN:'Indiana',IA:'Iowa',
    KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',MD:'Maryland',
    MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',MS:'Mississippi',MO:'Missouri',
    MT:'Montana',NE:'Nebraska',NV:'Nevada',NH:'New Hampshire',NJ:'New Jersey',
    NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',OH:'Ohio',
    OK:'Oklahoma',OR:'Oregon',PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',
    SD:'South Dakota',TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',
    VA:'Virginia',WA:'Washington',WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming',
    DC:'Washington DC',
};

const items = [{
    label: 'Marketing Package',
    name: 'MEDIA_KIT'
}];

const itemsNoLabel = [{
    label: '',
    name: 'MEDIA_KIT'
}];

const photos = [{
    label: 'Photo 1',
    name: 'WEBSITE_PHOTO_1',
}, {
    label: 'Photo 2',
    name: 'WEBSITE_PHOTO_2',
}, {
    label: 'Photo 3',
    name: 'WEBSITE_PHOTO_3',
}, {
    label: 'Photo 4',
    name: 'WEBSITE_PHOTO_4',
}, {
    label: 'Photo 5',
    name: 'WEBSITE_PHOTO_5',
}];

async function openEmailWithHtml(subject, intro, linkUrl, linkLabel) {
    const htmlBody =
        '<html><body style="font-family:Calibri,sans-serif;font-size:12pt;">' +
        '<p style="margin:0 0 12px 0;">' + intro + '</p>' +
        '<p style="margin:0 0 12px 0;"><a href="' + linkUrl + '">' + linkLabel + '</a></p>' +
        '<p style="margin:0 0 12px 0;">If you have any questions or further interest, please let me know.</p>' +
        '</body></html>';

    // Write HTML to clipboard — same mechanism as pasting a signature into Gmail.
    // Any rich-text compose window (Outlook, Gmail, OWA, Apple Mail) will render it on Ctrl+V.
    try {
        await navigator.clipboard.write([
            new ClipboardItem({
                'text/html': new Blob([htmlBody], { type: 'text/html' }),
                'text/plain': new Blob([intro + '\n' + linkUrl], { type: 'text/plain' }),
            }),
        ]);
    } catch (_) {
        // Clipboard API unavailable — mailto will still open, body just won't be pre-filled
    }

    // Open default email client with subject pre-filled
    window.location.href = 'mailto:?subject=' + encodeURIComponent(subject);
}

async function copyRichLink(html, plain) {
    try {
        await navigator.clipboard.write([
            new ClipboardItem({
                'text/html': new Blob([html], { type: 'text/html' }),
                'text/plain': new Blob([plain], { type: 'text/plain' }),
            }),
        ]);
    } catch (_) {
        await navigator.clipboard.writeText(plain);
    }
}

const CopyIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
    </svg>
);

const EmailIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
        <polyline points="22,6 12,13 2,6"/>
    </svg>
);

const Website = ({data, handleChangeInput, handleChangeFile, handleChangeFiles, viewMode, deleted, locks}) => {
    const [flipCopied, setFlipCopied] = useState(false);
    const [mediaCopied, setMediaCopied] = useState(false);
    const [flipEmailHint, setFlipEmailHint] = useState(false);
    const [mediaEmailHint, setMediaEmailHint] = useState(false);

    const stateName = STATE_NAMES[data.STATE] || data.STATE || '';
    const flipLabel = `${data.NAME || ''} - ${data.CITY || ''}, ${stateName}`;
    const mediaKitUrl = data.MEDIA_KIT ? `${arc.path.media}${data.MEDIA_KIT}` : null;

    const handleCopyFlipBook = () => {
        if (!data.FLIP_BOOK) return;
        const html = `<a href="${data.FLIP_BOOK}">${flipLabel}</a>`;
        copyRichLink(html, flipLabel).then(() => {
            setFlipCopied(true);
            setTimeout(() => setFlipCopied(false), 2000);
        });
    };

    const handleCopyMedia = () => {
        if (!mediaKitUrl) return;
        const html = `<a href="${mediaKitUrl}">${flipLabel}</a>`;
        copyRichLink(html, flipLabel).then(() => {
            setMediaCopied(true);
            setTimeout(() => setMediaCopied(false), 2000);
        });
    };

    const handleEmailMedia = () => {
        if (!mediaKitUrl) return;
        openEmailWithHtml(
            flipLabel,
            'Please click the following link to download the marketing package:',
            mediaKitUrl,
            flipLabel
        ).then(() => {
            setMediaEmailHint(true);
            setTimeout(() => setMediaEmailHint(false), 4000);
        });
    };

    const handleEmailFlipBook = () => {
        if (!data.FLIP_BOOK) return;
        openEmailWithHtml(
            flipLabel,
            'Please click the following link to view the flip book:',
            data.FLIP_BOOK,
            flipLabel
        ).then(() => {
            setFlipEmailHint(true);
            setTimeout(() => setFlipEmailHint(false), 4000);
        });
    };

    return (
        <div className="Website">
            <div className="Website_actions">
                {/*
                <Checkbox
                    text="FEATURED"
                    type={viewMode || isFieldLocked(locks, "FEATURED") ? "uncheckable" : "checkable"}
                    isSelected={data.FEATURED}
                    handleClick={handleChangeInput}
                    name="FEATURED"
                /> */}
                <Checkbox
                    text="VISIBLE"
                    type={viewMode || isFieldLocked(locks, "VISIBLE") ? "uncheckable" : "checkable"}
                    isSelected={data.VISIBLE}
                    handleClick={handleChangeInput}
                    name="VISIBLE"
                />
            </div>
            <div className="Website_column">
                <div className="Website_link-field">
                    <div className="Website_link-header">
                        <span className="Website_field-label">Marketing Package</span>
                        {data.MEDIA_KIT && (
                            <div className="Website_link-actions">
                                <button
                                    type="button"
                                    className={`website-action-btn${mediaCopied ? ' copied' : ''}`}
                                    onClick={handleCopyMedia}
                                    title={mediaCopied ? 'Copied!' : 'Copy link'}>
                                    <CopyIcon />
                                </button>
                                <div className="email-btn-wrap">
                                    <button
                                        type="button"
                                        className="website-action-btn"
                                        onClick={handleEmailMedia}>
                                        <EmailIcon />
                                    </button>
                                    <span className="email-btn-tooltip">Copies link to clipboard — just paste it in your email</span>
                                </div>
                                {mediaEmailHint && <span className="website-email-hint">Paste into email body (Ctrl+V)</span>}
                            </div>
                        )}
                    </div>
                    <UploadFiles
                        classNames="Website_column_item"
                        data={data}
                        viewMode={viewMode}
                        deleted={deleted}
                        handleChangeFile={handleChangeFile}
                        maxFilesAmount={items.length}
                        items={itemsNoLabel}
                        canUploadManually
                        handleChangeInput={handleChangeInput}
                        droppable
                    />
                </div>
                <Input
                    className="Website_column_item"
                    type="text"
                    valueType="text"
                    name="VIDEO_URL"
                    label="VIDEO LINK"
                    value={data.VIDEO_URL}
                    disabled={isFieldLocked(locks, "VIDEO_URL")}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    hyperlink={true}
                />
                <div className="Website_link-field">
                    <div className="Website_link-header">
                        <span className="Website_field-label">Flip Book</span>
                        {data.FLIP_BOOK && (
                            <div className="Website_link-actions">
                                <button
                                    type="button"
                                    className={`website-action-btn${flipCopied ? ' copied' : ''}`}
                                    onClick={handleCopyFlipBook}
                                    title={flipCopied ? 'Copied!' : 'Copy link'}>
                                    <CopyIcon />
                                </button>
                                <div className="email-btn-wrap">
                                    <button
                                        type="button"
                                        className="website-action-btn"
                                        onClick={handleEmailFlipBook}>
                                        <EmailIcon />
                                    </button>
                                    <span className="email-btn-tooltip">Copies link to clipboard — just paste it in your email</span>
                                </div>
                                {flipEmailHint && <span className="website-email-hint">Paste into email body (Ctrl+V)</span>}
                            </div>
                        )}
                    </div>
                    <Input
                        className="Website_column_item"
                        type="text"
                        valueType="text"
                        name="FLIP_BOOK"
                        label=""
                        value={data.FLIP_BOOK}
                        disabled={isFieldLocked(locks, "FLIP_BOOK")}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        hyperlink={true}
                        hyperlinkLabel={data.FLIP_BOOK ? flipLabel : ''}
                    />
                </div>
                <Textarea
                    className="Website_column_item"
                    disabled={isFieldLocked(locks, "HIGHLIGHTS")}
                    label="Highlights"
                    name="HIGHLIGHTS"
                    value={data.HIGHLIGHTS}
                    maxWidth="100%"
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isList={true}
                />
            </div>
            <div className="Website_column">
                <UploadFiles
                    classNames="Website_column_item"
                    data={data}
                    viewMode={viewMode}
                    deleted={deleted}
                    handleChangeFile={handleChangeFile}
                    handleChangeFiles={handleChangeFiles}
                    maxFilesAmount={photos.length}
                    items={photos}
                    fileType={fileTypes.Photo}
                    droppable
                    collapseOnRemove={!!handleChangeFiles}
                />
            </div>
        </div>
    );
};

export default Website;
